import { TMachine } from "../../common/types";
import { TUser } from "../../common/types/user";
import { TUserMachineRole, UserMachineRole } from "../../common/types/user-machine-role";
import { TUserMachineWithRole } from "./types";

const addRoleToMachineList = (list: TMachine[] = [], role: TUserMachineRole): TUserMachineWithRole[] => list.map(item => ({
    ...item,
    role,
}));

export const getAllUserRelatedMachines = (data: TUser): TUserMachineWithRole[] => {
    let arr: TUserMachineWithRole[] = [];

    if (data) {
        arr = [
            ...addRoleToMachineList(data.dealerDevices, UserMachineRole.DEALER),
            ...addRoleToMachineList(data.ownedDevices, UserMachineRole.OWNER),
            ...addRoleToMachineList(data.operatedDevices, UserMachineRole.OPERATOR),
        ];
    }

    return arr;
};
